// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticoliSection_root__SPI4E","slider":"ArticoliSection_slider__XPYPO","rotation":"ArticoliSection_rotation__T2hRK"};